<template>
  <div class="reports-add-jobs">
    <el-button
      style="width: 100%"
      :disabled="!!disabled"
      size="small" class="add" :type="isSelect ? 'default' : 'primary'" @click="openDialog"
    >
      {{ isSelect ? 'Сменить Объект' : '+ Выбрать Объект' }}
    </el-button>

    <el-dialog append-to-body title="Выбрать объект" :visible.sync="dialogObject">
      <div class="add-jobs" v-loading="loader">
        <div style="margin-bottom: 18px" class="object-back">
          <div v-if="selectParent" @click="backObject()">
            <i class="el-icon-back"></i>
          </div>
          <div>
            <el-switch @change="switchChange" v-model="isObjectList">
            </el-switch>
            <strong>Иерархический вид</strong>
          </div>
        </div>
        <el-input placeholder="Поиск ..." v-model="search" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <div class="jobs-ul">
          <div
            v-if="selectParent"
            @click="save(selectParent, true)"
            class="jobs-li"
          >
            <strong>{{ selectParent.name }}</strong>
          </div>
          <div
            @click="save(list)"
            class="jobs-li" v-for="(list, index) in filteredList" :key="index"
          >
            <span>{{ list.name }}</span>
          </div>

          <div class="jobs-li link" v-if="role === 'admin'">
            <router-link to="/dashboard/objects">+ Добавить новый объект</router-link>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {getChildList} from '@/utils/getChild';
import _ from 'lodash';
import {filterObjects} from "../../../../utils/filterJobs";
import {getPermission, getPermissionByUser} from "../../../../firestore/permission";
import dayjs from "dayjs";
import {isCache} from "../../../../plugins/firebase";
import is from "vue2-datepicker/locale/es/is";
import th from "vue2-datepicker/locale/es/th";

export default {
  name: 'AddObjects',
  props: ['isSelect', 'confirmDisable', 'disabled'],
  data() {
    return {
      search: '',
      dialogObject: false,
      permissionUser: null,
      unit: '',
      loader: true,
      role: 'admin',
      selectParent: null,
      prevParent: [null],
      isObjectList: false,
      list: [],
      form: {
        value: '',
        unit: '',
      },
    };
  },
  computed: {
    filteredList() {
      return this.list.filter(object => {
        try {
          return object.name.toLowerCase().includes(this.search.toLowerCase());
        } catch (e) {
          return !!this.search
        }
      });
    },
  },

  async mounted() {
    this.selectParent = null;
    this.prevParent = [null]
    this.isObjectList = this.$store.state.project.object_list

    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || firebase.auth().currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id));

    if (!this.$store.state.project.version) {
      this.permissionUser = await getPermissionByUser(this.$store.state.project.id, firebase.auth().currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id) || null);
    }



    if(this.isObjectList) {
      this.fetchByList();
    } else {
      this.fetchTree();
    }
    firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id).get().then((sub) => {
      const data = sub.data();
      if (data) {
        const rules = data.rules;
        if (rules) {
          this.role = rules[firebase.auth().currentUser.uid];

          if (data.isDemo) {
            this.role = 'admin';
          }
          this.loading = false;
        }
      }
    });
  },

  methods: {
    switchChange(flag) {
      if(flag) {
        this.fetchByList()
      } else {
        this.fetchTree()
      }
    },
    backObject() {
        this.selectParent = this.prevParent[this.prevParent.length - 1]
      if(this.prevParent.length > 1) {
        this.prevParent.pop()
        this.prevParent = [...this.prevParent]
      }
        this.fetchByList(this.selectParent ? this.selectParent.id : null);
    },
    fire() {
      if (this.$route.query.version) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.query.version)
      }

      if (this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id)) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id))
      }

      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    fetchByList(parentId = null) {
      this.loader = true;
      const result = [];

      this.fire()
        .collection('objects')
        .where('parentId', '==', parentId)
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(() => {
        if (!result.length) {
          let objectName = ''
          this.prevParent.forEach((obj) => {
            console.log(name, 'name')
            if (obj) {
              if(objectName) {
                objectName = objectName + ' > ' + obj.name
              } else {
                objectName =  obj.name

              }

              console.log(objectName, 'objectName')
            }
          })


          this.$emit('add-objects', {
            name: objectName ? ( objectName+ ' > ' + this.selectParent.name) : this.selectParent.name,
            id: this.selectParent.id,
          });
          this.close();
        }

        this.list = _.orderBy(filterObjects(filterObjects(result, this.permission), this.permissionUser), 'index', ['asc']);
        this.loader = false;
      }).catch((e) => {
        console.error(e)
        this.loader = false;
      });
    },
    fetchTree() {
      this.loader = true;
      const result = [];


      const path = 'OBJECT_' + this.fire().path

      const cache = localStorage.getItem(path);


      if (!cache || Number(JSON.parse(cache).expire) < dayjs().unix()) {
        this.fire()
          .collection('objects')
          .get()
          .then((data) => {
            data.forEach((subDoc) => {
              const data = subDoc.data();
              result.push({
                id: subDoc.id,
                name: data.name,
                objects: data.objects,
                index: data.index,
                parentId: data.parentId || undefined,
                isParent: data.isParent,
              });
            });
          }).finally(() => {
          // if(isCache) {
          localStorage.setItem(path, JSON.stringify({result, expire: dayjs().add(10, 'minute').unix()}))
          // }

          this.list = _.orderBy(filterObjects(filterObjects(getChildList(result), this.permission), this.permissionUser), 'index', ['asc']);
          this.loader = false;
        }).catch(() => {
          this.loader = false;
        });
      } else {
        this.list = _.orderBy(filterObjects(filterObjects(getChildList(JSON.parse(cache).result), this.permission), this.permissionUser), 'index', ['asc']);
        this.loader = false;
      }
    },
    openDialog() {
      if (this.confirmDisable) {
        this.$emit('add-objects', null);
        return this.dialogObject = true;
      }
      if (this.isSelect && this.$route.params.type !== 'TECH' && this.$route.params.type !== 'PROF') {
        this.$confirm('После смены объекта вся введенная информация по работам будет удалена, продолжить?', 'Подтверждение', {
          confirmButtonText: 'Да',
          cancelButtonText: 'Нет',
          type: 'warning',
        }).then(() => {
          this.selectParent = null;
          this.prevParent = [null]
          if ( this.isObjectList) {
            this.fetchByList()
          }
          this.$emit('add-objects', null);
          this.dialogObject = true;
        });
      } else {
        this.$emit('add-objects', '');
        this.dialogObject = true;
      }
    },
    save(object, isflag) {
      if (this.isObjectList && !isflag) {
        if(this.selectParent) {
          this.prevParent.push(JSON.parse(JSON.stringify(this.selectParent)))
        }
        this.selectParent = object
        this.fetchByList(this.selectParent.id)
      } else {
        this.$emit('add-objects', {
          name: object.name,
          id: object.id,
        });
        this.close();
      }
    },
    close() {
      this.dialogObject = false;
      this.clear();
    },
    clear() {
      this.form.value = '';
      this.form.unit = '';
    },
  },
};
</script>

<style lang="scss">
.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 4px 10px !important;
    width: calc(100% - 20px);
    justify-content: flex-start;
    text-align: left;
    height: auto !important;
    min-height: 48px !important;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    span {
      text-align: left;
    }

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

.object-back {
  display: flex;
  align-items: center;
  .el-icon-back {
    width: 50px;
    cursor: pointer;
  }
  i {
    font-size: 22px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/components/AddObjects.vue